<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_chooseItRight') }}
        game-preview-setting(v-if="parameters.amountOfExamples && !parameters.timeLimit")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_examples') }}
            span(slot="value") {{ parameters.amountOfExamples }}
        game-preview-setting(v-if="parameters.timeLimit")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
            span(slot="value") {{ timeLimit }}
        template(v-if="parameters.dictation")
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_dictation') }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}
                span(slot="value")
                    | {{ parameters.timeForAnswer }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
</template>

<script>
/*eslint-disable*/
import GamePreviewSettings from './GamePreviewSettings.vue'
import GamePreviewSetting from './GamePreviewSetting.vue'
import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

export default {
    props: ['parameters', 'exerciseId', 'type'],
    mixins: [GamePreviewMixin],
    components: {
        GamePreviewSettings,
        GamePreviewSetting
    },
    computed: {
        timeLimit() {
            return (
                this.parameters.timeLimit +
                ' ' +
                this.$i18n.tc('trainer.trainer_gamePreview_timeParamMinuteDeclination', this.parameters.timeLimit)
            );
        },
    }
}
</script>
